import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetTrips = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
  searchTerm
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/trips`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage: 10,
        institutionId: institutionId,
        searchKey: searchTerm,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching trips:", error);
    return error;
  }
};

export const APICreateTrip = async (
  tripData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...tripData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/trips`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating trip:", error);
    return error;
  }
};

export const APIUpdateTrip = async (
  tripData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/trips/`,
      {
        tripId: tripData._id,
        ...tripData,
      },
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating trip:", error);
    return error;
  }
};

export const APIDeleteTrips = async (tripId, setLoading, institutionId, token) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.delete(`${apiConfig.baseURL}/trips`, {
      headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: { tripId: tripId },
    });
    return result;
  } catch (error) {
    console.error("Error deleting trips:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIGenerateRoute = async (tripData, setLoading) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.post(
      `${apiConfig.baseURL}/trips/generate-route`,
      tripData,
      {
        headers: apiConfig.headers,
      }
    );
    return result;
  } catch (error) {
    console.error("Error generating route:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
